import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { ArrowLeft, ArrowRight } from '@shared/assets/icons';
import ControlArrow from './ControlArrow';
interface ControlRowProps extends HTMLAttributes<HTMLButtonElement> {
  direction?: 'right' | 'left';
  variant?: 'primary' | 'secondary';
  withArrowBg?: boolean;
  onClick?: () => void;
}
const ControlRow: FC<ControlRowProps> = ({
  direction,
  variant = 'primary',
  withArrowBg = false,
  onClick,
  ...rest
}) => <ControlRowWrapper type="button" direction={direction} variant={variant} onClick={onClick} {...rest}>
    {withArrowBg ? <ControlArrow size="24" direction={direction} /> : <IconWrapper>{direction === 'right' ? <ArrowRight /> : <ArrowLeft />}</IconWrapper>}
  </ControlRowWrapper>;
export default ControlRow;
type ControlRowWrapperProps = Pick<ControlRowProps, 'direction' | 'variant'>;
const _exp = /*#__PURE__*/() => ({
  direction,
  variant,
  theme
}) => `linear-gradient(${direction === 'right' ? '270deg' : '90deg'}, ${variant === 'secondary' ? theme.colors.background.secondary : theme.colors.background.primary} 0%, transparent 100%)`;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const ControlRowWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ControlRowWrapper",
  class: "c10zxm0g",
  propsAsIs: false,
  vars: {
    "c10zxm0g-0": [_exp()],
    "c10zxm0g-1": [_exp2()]
  }
}));
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1h5iyxt",
  propsAsIs: false
});

require("./ControlRow.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ControlRow.tsx");